import type {VehicleTipCarsPlatformAdvertisingSettings} from '../utils/VehicleTipCarsPlatformAdvertisingSettings';
import type {VehicleAutocarisPlatformAdvertisingSettings} from './VehicleAutocarisPlatformAdvertisingSettings';
import type {VehicleAutosoftPlatformAdvertisingSettings} from './VehicleAutosoftPlatformAdvertisingSettings';
import type {VehicleFacebookPlatformAdvertisingSettings} from './VehicleFacebookPlatformAdvertisingSettings';
import type {VehicleMobileDePlatformAdvertisingSettings} from './VehicleMobileDePlatformAdvertisingSettings';
import type {VehicleMyWebPlatformAdvertisingSettings} from './VehicleMyWebPlatformAdvertisingSettings';
import type {VehicleSAutoPlatformAdvertisingSettings} from './VehicleSAutoPlatformAdvertisingSettings';

export type VehiclePlatformAdvertisingSettings =
  | VehicleSAutoPlatformAdvertisingSettings
  | VehicleTipCarsPlatformAdvertisingSettings
  | VehicleMobileDePlatformAdvertisingSettings
  | VehicleMyWebPlatformAdvertisingSettings
  | VehicleFacebookPlatformAdvertisingSettings
  | VehicleAutocarisPlatformAdvertisingSettings
  | VehicleAutosoftPlatformAdvertisingSettings;
